
import { Component, Vue } from 'vue-property-decorator';

@Component<RecruiterPage>({})
export default class RecruiterPage extends Vue {}
